import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import EcoSpace from 'eco-design/base/eco-space';
import EcoTextTc, { EcoTextTcItemProps } from 'eco-design/sections/eco-text-tc';
import { useMemo } from 'react';
import { useProductStore } from '../../../../ProductProvider';
import styles from './index.module.scss';

export default function Comp() {
    const { t } = useLang('theProduct.FooterTcA');
    const { locale = 'us' } = getLocal();
    const { pageStatus } = useProductStore();
    const isEU = ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale);

    const NA_items = [
        {
            isHead: true,
            title: t('tishi'),
            titleColor: '#696C71',
        },
        {
            isHead: true,
            title: t('title'),
        },
        {
            isOpen: true,
            title: t('title1'),
            desc: t('desc1'),
        },
        {
            isOpen: true,
            title: t('title2'),
            desc: t('desc2'),
        },
        {
            isOpen: true,
            title: t('title3'),
            desc: t.rich('desc3', {
                e: (v: string) => `<a class="link" href="https://${v}" target="_blank">${v}</a>`,
            }),
        },
        {
            isOpen: true,
            title: t('title4'),
            desc: t.rich('desc4', {
                e: (v: string) => `<a class="link" href="https://${v}" target="_blank">${v}</a>`,
            }),
        },
        {
            isOpen: true,
            title: t('title5'),
            desc: t.rich('desc5', {
                e: (v: string) => `<a class="link" href="mailto:${v}" target="_blank">${v}</a>`,
            }),
        },
    ].filter(Boolean) as EcoTextTcItemProps[];
    const JP_items = [
        {
            isOpen: true,
            title: t('title'),
            desc: t('desc'),
        },
        {
            isOpen: true,
            title: t('title2'),
            desc: t.rich('desc2', {
                e: (v: string) => `<a class="link" href="mailto:${v}" target="_blank">${v}</a>`,
                l: (v: string) => `<a class="link" href="https://jp.ecoflow.com/pages/online-store-policy" target="_blank">${v}</a>`,
                l2: (v: string) => `<a class="link" href="https://jp.ecoflow.com/products/glacier-classic-portable-refrigerator" target="_blank">${v}</a>`,
            }),
        },
    ];
    const EU_items = [
        {
            isHead: true,
            title: t('title'),
        },
        {
            isOpen: true,
            title: t('title2'),
            desc: t('desc2'),
        },
        {
            isOpen: true,
            title: t('title3'),
            desc: t('desc3'),
        },
        {
            isOpen: true,
            title: t('title4'),
            desc: t.rich('desc4', {
                l: (v: string) => `<a class="link" href="https://${v}" target="_blank">${v}</a>`,
            }),
        },
        {
            isOpen: true,
            title: t('title5'),
            desc: t.rich('desc5', {
                e: (v: string) => `<a class="link" href="https://${v}" target="_blank">${v}</a>`,
            }),
        },
        {
            isOpen: true,
            title: t('title6'),
            desc: t.rich('desc6', {
                e: (v: string) => `<a class="link" href="mailto:${v}" target="_blank">${v}</a>`,
                l: (v: string) => `<a class="link" href="${v}" target="_blank">${v}</a>`,
            }),
        },
    ];
    const AU_items = [
        {
            isHead: true,
            title: t('tips'),
        },
    ];
    const items = useMemo(() => {
        switch (locale) {
            case 'us':
            case 'ca':
                return NA_items;
            case 'jp':
                return JP_items;
            case 'eu':
            case 'uk':
            case 'de':
            case 'fr':
            case 'es':
            case 'it':
                return EU_items;
            case 'au':
                return AU_items;
            default:
                return NA_items;
        }
    }, [locale]);

    return (
        <>
            <EcoSpace />
            {!isEU && <EcoTextTc items={items} className={styles.comp} />}
        </>
    );
}
